import React from 'react';
import RangeSlider from "react-range-slider-input";
import "./RangeSliderFilter.css"
import {Field} from "formik";
import {FormikSetFieldValue} from "../../../types/CommonTypes";


type Props = {
    valueRange: [number, number];
    title:string
    nameFieldFrom:string
    nameFieldTo:string
    setFieldValue:FormikSetFieldValue

}
const RangeSliderFilter: React.FC<Props> = ({valueRange, setFieldValue,title,nameFieldTo,nameFieldFrom}) => {

    const MIN_VALUE = 0;
    const MAX_VALUE = 10000;

    const clamp = (val: number, min = MIN_VALUE, max = MAX_VALUE) => Math.min(max, Math.max(min, val));

    // Нормализуем входные значения для слайдера (безопасные числа)
    const fromVal = clamp(Number.isFinite(valueRange?.[0]) ? Number(valueRange[0]) : MIN_VALUE);
    const toValRaw = Number.isFinite(valueRange?.[1]) ? Number(valueRange[1]) : MIN_VALUE;
    // Допускаем "пустое" верхнее значение как 0 (без ограничения)
    const toVal = clamp(toValRaw);
    const sliderValue: [number, number] = (
        toVal !== 0 && fromVal > toVal
            ? [toVal, toVal]
            : [fromVal, toVal]
    );

    const onInput = (value:[number,number])=>{
        const [nextFrom, nextTo] = value;
        const nf = clamp(nextFrom);
        const nt = clamp(nextTo);
        // Если вводим from больше to (и to не пустой/0) — подтягиваем to
        if (nt !== 0 && nf > nt) {
            setFieldValue(nameFieldFrom, nt);
            setFieldValue(nameFieldTo, nt);
            return;
        }
        setFieldValue(nameFieldFrom, nf);
        setFieldValue(nameFieldTo, nt);
    }

    const handleFromChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
        const raw = e.currentTarget.value;
        if (raw === '') {
            // Пустой ввод трактуем как 0 для from
            setFieldValue(nameFieldFrom, MIN_VALUE);
            return;
        }
        const num = clamp(Number(raw.replace(/[^0-9]/g, '')));
        // Если верхняя граница задана (не 0) и стала меньше нижней — подтянем верхнюю
        if (toVal !== 0 && num > toVal) {
            setFieldValue(nameFieldFrom, toVal);
            return;
        }
        setFieldValue(nameFieldFrom, num);
    };

    const handleToChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
        const raw = e.currentTarget.value;
        if (raw === '') {
            // Пустой ввод — снимаем верхнюю границу (0)
            setFieldValue(nameFieldTo, MIN_VALUE);
            return;
        }
        const num = clamp(Number(raw.replace(/[^0-9]/g, '')));
        // Если верхняя граница стала ниже нижней — подтянем нижнюю
        if (num !== 0 && num < fromVal) {
            setFieldValue(nameFieldFrom, num);
        }
        setFieldValue(nameFieldTo, num);
    };

    const renderInputValue = (value: number, allowZeroAsEmpty = false) => {
        if (allowZeroAsEmpty && value === MIN_VALUE) {
            return '';
        }
        return Number.isFinite(value) ? String(value) : '';
    };

    return (
        <div className="form-filter__item form-filter__item-range">
            <div className="form-filter__label">
                {title}
            </div>
            <div className="form-filter__row">
                <div className="range-filter">
                    <div className="range-filter__values values-range-filter">
                        <div className="values-range-filter__column">
                            <div className="values-range-filter__input">
                                <Field name={nameFieldFrom}>
                                    {({field}: any) => (
                                        <input
                                            {...field}
                                            id={nameFieldFrom}
                                            placeholder="0"
                                            autoComplete="off"
                                            type="text"
                                            inputMode="numeric"
                                            className="input"
                                            value={renderInputValue(field.value ?? sliderValue[0])}
                                            onChange={handleFromChange}
                                        />
                                    )}
                                </Field>
                            </div>
                        </div>
                        <div className="values-range-filter__column">
                            <div className="values-range-filter__input">
                                <Field name={nameFieldTo}>
                                    {({field}: any) => (
                                        <input
                                            {...field}
                                            id={nameFieldTo}
                                            placeholder=""
                                            autoComplete="off"
                                            type="text"
                                            inputMode="numeric"
                                            className="input"
                                            value={renderInputValue(field.value ?? sliderValue[1], true)}
                                            onChange={handleToChange}
                                        />
                                    )}
                                </Field>
                            </div>
                        </div>
                    </div>
                    <RangeSlider value={sliderValue} id="range-slider" onInput={onInput} min={MIN_VALUE} max={MAX_VALUE}/>
                </div>
            </div>
        </div>
    );
};

export default RangeSliderFilter;